import { useAvatar, useProfile } from "hooks";
import ChangePassword from "pages/Authentication/ChangePassword";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  Col,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
} from "reactstrap";
// users
import avatar from "../../../assets/images/users/avatar-default.png";

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const [avatarImage, setAvatarImage] = useState("");
  const [avatarId, setAvatarId] = useState("");
  const [isOpenChangePassword, setIsOpenChangePassword] = useState(false);

  const onFetchProfileSuccess = async response => {
    const { data } = response;
    localStorage.setItem("user_type", data?.user_type);
    const id = data?.ext_value?.avatar_id;
    if (id) {
      setAvatarId(id);
      setTimeout(() => {
        fetchAvatar();
      }, 200);
    }
  };

  const onFetchAvatarSuccess = response => {
    setAvatarImage(response);
  };

  const {
    data: { data: profile },
    isFetching: isFetchingProfile,
    refetch: refetchProfile,
  } = useProfile(onFetchProfileSuccess);

  const { refetch: fetchAvatar } = useAvatar(
    { avatarId: avatarId },
    onFetchAvatarSuccess
  );

  useEffect(() => {
    const interval = setInterval(() => {
      refetchProfile();
    }, 600000);
    return () => clearInterval(interval);
  }, []);

  const { t } = useTranslation("translation");

  const toggleChangePassword = () =>
    setIsOpenChangePassword(!isOpenChangePassword);

  return (
    <React.Fragment>
      <Row>
        <Col lg="12">
          <ChangePassword
            isOpenModal={isOpenChangePassword}
            toggleModal={toggleChangePassword}
          />
        </Col>
      </Row>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          {isFetchingProfile ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner color="primary" />
            </div>
          ) : (
            <React.Fragment>
              <img
                className="rounded-circle header-profile-user"
                src={avatarImage || avatar}
                alt="Header Avatar"
              />
              <span className="d-none d-xl-inline-block ms-2 me-1">
                {profile?.display_name}
              </span>
              <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
            </React.Fragment>
          )}
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <Link to="/profile" className="dropdown-item">
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {t("Profile")}
          </Link>
          <div className="dropdown-divider" />
          <Link to="/change-password" className="dropdown-item">
            <i className="bx bx-lock font-size-16 align-middle me-1" />
            {t("change_password")}
          </Link>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};

export default ProfileMenu;
